import './styles.scss';

import Autocomplete, { ReactGoogleAutocompleteInputProps } from 'react-google-autocomplete';
import { ReactElement, forwardRef, useLayoutEffect, useState } from 'react';

import { getClasses } from '@/utils';
import { getMapConfig } from '@/api/services/config/getPortalConfig';

export type LocationInputProps = Omit<ReactGoogleAutocompleteInputProps, 'onChange' | 'onPlaceSelected'> & {
  name: string;
  className?: string;
  onChange?: (fullAddress: string, place?: google.maps.places.PlaceResult) => void;
  defaultValue?: string;
  placeholder?: string;
};

const LocationInput = ({ className, onChange, placeholder, ...props }: LocationInputProps, ref): ReactElement => {
  const [state, setState] = useState({ data: undefined, loading: false });
  const { data: googleMapsApiKey, loading } = state;

  const handleGetMapConfig = async (): Promise<void> => {
    setState((current) => ({ ...current, loading: true }));
    const res = await getMapConfig();
    setState((current) => ({ ...current, data: res, loading: false }));
  };

  useLayoutEffect((): void => {
    handleGetMapConfig();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (!googleMapsApiKey) return <div>Error loading Google Maps API key</div>;

  return (
    <Autocomplete
      {...props}
      ref={ref}
      className={getClasses('LocationInput', 'form-control', className)}
      apiKey={googleMapsApiKey}
      onChange={(e: any) => onChange(e.target.value)}
      onPlaceSelected={(places, target: any) => onChange(target.value, places)}
      placeholder={placeholder}
      options={{
        types: [], // to view all types we pass []; without this the types is limited to cities only
        fields: ['name', 'formatted_address', 'geometry', 'place_id', 'types'], // get address parts
      }}
    />
  );
};

export default forwardRef(LocationInput);
